/* eslint import/prefer-default-export: "off" */
export function createSorter(key, type) {
    const getValue = (obj, path) => {
        return path.split('.').reduce((acc, keys) => acc?.[keys], obj);
    };
    return (a, b) => {
        switch (type) {
            case 'string':
                const aStr = getValue(a, key)?.toLowerCase() || '';
                const bStr = getValue(b, key)?.toLowerCase() || '';
                return aStr.localeCompare(bStr);

            case 'number':
                return (getValue(a, key) || 0) - (getValue(b, key) || 0);

            case 'date':
                return new Date(getValue(a, key)) - new Date(getValue(b, key));

            case 'boolean':
                const aVal = getValue(a, key);
                const bVal = getValue(b, key);
                if (aVal === bVal) return 0;
                return aVal ? -1 : 1;

            default:
                return 0;
        }
    };
};